import { makeObservable, observable, runInAction } from 'mobx'
import { EntityTypeApi } from '@portal/pkg-api/navigator'
import { EntityType } from '@migrate/models/EntityType'

import { find, some } from 'lodash-es'
import { data } from '@portal/pkg-api/shared'

export class EntityTypeStore {
  transportLayer: typeof EntityTypeApi
  @observable entityTypes: EntityType[] = []
  @observable public ready: boolean

  public static STORE_NAME = 'entityTypeStore'
  get storeName() {
    return EntityTypeStore.STORE_NAME
  }

  constructor(transportLayer: typeof EntityTypeApi) {
    this.transportLayer = transportLayer // Thing that can make server requests for us
    this.ready = false
    makeObservable(this)
  }

  async load() {
    runInAction(() => {
      this.ready = false
      this.entityTypes = []
    })
    const fetched = await data(this.transportLayer.getEntityTypes())
    fetched.forEach((json: any) => this.updateFromServer(json))
    runInAction(() => {
      this.ready = true
    })
  }

  updateFromServer(json: EntityType) {
    let model = find(this.entityTypes, function (modelI: EntityType) {
      return modelI.id === json.id
    })
    if (!model) {
      model = new EntityType(this, json.id)
      this.entityTypes.push(model)
    }
    if (json.isDeleted) {
      this.remove(model)
    } else {
      model.updateFromJson(json)
    }
  }

  // todo: need to determine what to send to server for new id's
  create() {
    const model = new EntityType(this, -1)
    this.entityTypes.push(model)
    return model
  }

  remove(model: EntityType) {
    this.entityTypes.splice(this.entityTypes.indexOf(model), 1)
    model.dispose()
  }

  findById(id: number) {
    return find(this.entityTypes, function (model: EntityType) {
      return model.id === id
    })
  }

  findByCode(code: string) {
    return find(this.entityTypes, (model) => model.code === code)
  }

  getActiveTypes() {
    return this.entityTypes.filter((type) => type.enabled)
  }

  getTopLevelTypes() {
    return this.entityTypes.filter((type) => type.enabled && !type.requiresSubEntity)
  }

  getEffectiveColor(entityTypeId?: number): string {
    const defaultColor = '#bdbdbd'
    if (entityTypeId) {
      const entityType = this.findById(entityTypeId)
      return entityType ? entityType.effectiveColor! : defaultColor
    }
    return defaultColor
  }

  getEntityType(entityTypeId: number) {
    const entityType = this.findById(entityTypeId)
    return entityType ? entityType : null
  }

  getParents(entityTypeId: number) {
    const parents = this.entityTypes.filter((type: EntityType) => {
      return some(type.successors, ['id', entityTypeId])
    })
    return parents
  }
}
